import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@material';
import { PipeModule } from '@pipes/pipes.module';
import { FirebaseModule } from '../services/firebase';
import { DirectivesModule } from './directives/directives.module';
import { MarketplacePartnerToken } from './tokens/marketplace-partner.token';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FirebaseModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    DirectivesModule,
  ],
  exports: [
    DirectivesModule,
    PipeModule,
  ],
  declarations: [],
  providers: [
    {
      provide: MarketplacePartnerToken,
      useValue: '005056887b8d-b5da-11e6-9f54-cea38574',
    },
  ],
})
export class CoreModule {
}
